import {REQUIRED_LEVEL} from "./access";

function getManagerTypes(appName, userApproved, accessLevel) {
  const managerTypes = {
    "Cy": [
      { code: "All", name: "All 2000", allowBackTested: true },
      { code: "All 2008", name: "All 2008", allowBackTested: true },
      { code: "All 10 Year", name: "All 10 Year", allowBackTested: true },
      { code: "All 5 Year", name: "All 5 Year", allowBackTested: true },
      { code: "ETF Only", name: "ETF 2000", allowBackTested: false },
      { code: "ETF 2008", name: "ETF 2008", allowBackTested: false },
      { code: "ETF 10 Year", name: "ETF 10 Year", allowBackTested: false },
      { code: "ETF 5 Year", name: "ETF 5 Year", allowBackTested: false },
      { code: "ETF Bond", name: "ETF Bond 10 Year", allowBackTested: false },
      // { code: "FLX Blend 5 Year", name: "FLX Blend 5 Year"},
      // { code: "Cy FLX Blend ENV 5 Year", name: "FLX Blend ENV 5 Year"},
      // { code: "PIMCO Blend", name: "PIMCO Blend"},
      // { code: "PIMCO Bond", name: "PIMCO Bond"},
      { code: "ETF Bond Short Duration", name: "ETF Bond Short Duration 5 Year", allowBackTested: false },
      { code: "ETF Bond Ultra Short Duration", name: "ETF Bond Ultra Short Duration 5 Year", allowBackTested: false },
      { code: "ETF Bond Municipal", name: "ETF Bond Municipal 10 Year", allowBackTested: false },
      // { code: "ERISA", name: "ETF ERISA 2008", allowBackTested: false },
      { code: "ERISA", name: "ETF ERISA 2008", allowBackTested: false },
      { code: "ETF Commodities & Metals", name: "ETF Commodities & Metals 3 Year", allowBackTested: false },
      { code: "ETF Alternative Income", name: "ETF Alternative Income 5 Year", allowBackTested: false },
      { code: "ETF Innovation", name: "ETF Innovation 3 Year", allowBackTested: true },
      { code: "ETF International", name: "ETF International 5 Year", allowBackTested: false },
      { code: "SMA 10 Year", name: "SMA 10 Year", allowBackTested: true },
      { code: "SMA 5 Year", name: "SMA 5 Year", allowBackTested: true },
      // { code: "Mutual Fund 1980", name: "Mutual Fund 1980", allowBackTested: false },
      { code: "WBI Blend", name: "WBI Blend 2000", allowBackTested: true },
      { code: "WBI Blend 2008", name: "WBI Blend 2008", allowBackTested: true },
      { code: "WBI Blend 10 Year", name: "WBI Blend 10 Year", allowBackTested: true },
      { code: "WBI Blend 5 Year", name: "WBI Blend 5 Year", allowBackTested: true },
      ...(userApproved ? [{ code: "WBI Portfolios", name: "WBI SMAs", allowBackTested: false }] : []),
      ...(userApproved ? [{ code: "WBI Envestnet", name: "WBI Envestnet", allowBackTested: false }] : []),
      ...(userApproved ? [{ code: "Other Models", name: "Other Models", allowBackTested: false }] : []),
    ],
    "Maridea Wealth Management": [
      { code: "All", name: "All 2000", allowBackTested: true },
      { code: "All 2008", name: "All 2008", allowBackTested: true },
      { code: "ETF Only", name: "ETF 2000", allowBackTested: false },
      { code: "ETF 2008", name: "ETF 2008", allowBackTested: false },
      { code: "ETF 10 Year", name: "ETF 10 Year", allowBackTested: false },
      { code: "ETF 5 Year", name: "ETF 5 Year", allowBackTested: false },
      { code: "ETF Bond", name: "ETF Bond 10 Year", allowBackTested: false },
      // { code: "FLX Blend 5 Year", name: "FLX Blend 5 Year"},
      // { code: "Cy FLX Blend ENV 5 Year", name: "FLX Blend ENV 5 Year"},
      // { code: "PIMCO Blend", name: "PIMCO Blend"},
      // { code: "PIMCO Bond", name: "PIMCO Bond"},
      { code: "ETF Bond Short Duration", name: "ETF Bond Short Duration 5 Year", allowBackTested: true },
      { code: "ETF Bond Ultra Short Duration", name: "ETF Bond Ultra Short Duration 5 Year", allowBackTested: false },
      { code: "ETF Bond Municipal", name: "ETF Bond Municipal 10 Year", allowBackTested: false },
      // { code: "ERISA", name: "ETF ERISA 2008", allowBackTested: false },
      { code: "ERISA", name: "ETF ERISA 2008", allowBackTested: false },
      // { code: "ETF ESG", name: "ETF ESG 5 Year", allowBackTested: false },
      { code: "ETF Innovation", name: "ETF Innovation 3 Year", allowBackTested: true },
      { code: "ETF International", name: "ETF International 5 Year", allowBackTested: false },
      // { code: "Mutual Fund 1980", name: "Mutual Fund 1980", allowBackTested: false },
      { code: "WBI Blend", name: "WBI Blend 2000", allowBackTested: true },
      { code: "WBI Blend 2008", name: "WBI Blend 2008", allowBackTested: true },
      { code: "WBI Blend 10 Year", name: "WBI Blend 10 Year", allowBackTested: true },
      { code: "WBI Blend 5 Year", name: "WBI Blend 5 Year", allowBackTested: true },
      ...(userApproved ? [{ code: "WBI Portfolios", name: "WBI SMAs", allowBackTested: false }] : []),
      ...(userApproved ? [{ code: "WBI Envestnet", name: "WBI Envestnet", allowBackTested: false }] : []),
      ...(userApproved ? [{ code: "Other Models", name: "Other Models", allowBackTested: false }] : []),
    ],
    "American Portfolios": [
      { code: "All", name: "All", allowBackTested: true  },
      { code: "ETF Only", name: "ETF", allowBackTested: false },
      { code: "ETF 10 Year", name: "ETF 10 Year", allowBackTested: false },
      { code: "ETF 5 Year", name: "ETF 5 Year", allowBackTested: false },
      { code: "ETF ESG", name: "ETF ESG", allowBackTested: false  },
      { code: "ETF Bond", name: "ETF Bond", allowBackTested: false },
      // { code: "FLX Blend 5 Year", name: "FLX Blend 5 Year"},
      { code: "ETF Bond Short Duration", name: "ETF Bond Short Duration", allowBackTested: false  },
      { code: "ETF Bond Ultra Short Duration", name: "ETF Bond Ultra Short Duration", allowBackTested: false },
      { code: "ETF Bond Municipal", name: "ETF Bond Municipal", allowBackTested: false },
      // ...(accessLevel < REQUIRED_LEVEL.PREMIUM ? [{ code: "ERISA", name: "ERISA", allowBackTested: false  }] : []),
      { code: "WBI Blend", name: "WBI Blend", allowBackTested: true },
      { code: "WBI Blend 10 Year", name: "WBI Blend 10 Year", allowBackTested: true },
      { code: "WBI Blend 5 Year", name: "WBI Blend 5 Year", allowBackTested: true },
    ]
  }
  return managerTypes[appName] || [];
}


const disabledOnboarding = (portfolioMetadata) => {
  const DISABLE_ONBOARDING_MAP = {
    "managerType": ['Mutual Fund 1980', 'WBI Envestnet'],
    "singleStrategy": [
      'LPL.mdd.05', 'LPL.mdd.10', 'LPL.mdd.15', 'LPL.mdd.20', 'LPL.mdd.25', 'LPL.mdd.30', 'LPL.mdd.35', 'LPL.mdd.40',
      'RPM.mdd.05', 'RPM.mdd.10', 'RPM.mdd.15', 'RPM.mdd.20', 'RPM.mdd.25', 'RPM.mdd.30', 'RPM.mdd.35', 'RPM.mdd.40',
      'LPL Eligible.mdd.05', 'LPL Eligible.mdd.10', 'LPL Eligible.mdd.15', 'LPL Eligible.mdd.20', 'LPL Eligible.mdd.25', 'LPL Eligible.mdd.30', 'LPL Eligible.mdd.35', 'LPL Eligible.mdd.40',
      'LPL NTF.mdd.05', 'LPL NTF.mdd.10', 'LPL NTF.mdd.15', 'LPL NTF.mdd.20', 'LPL NTF.mdd.25', 'LPL NTF.mdd.30', 'LPL NTF.mdd.35', 'LPL NTF.mdd.40',
      'Monument Advisor 2008.mdd.20', 'Monument Advisor 2008.mdd.30', 'Monument Advisor 2008.mdd.40',
      'Monument Advisor Select 2008.mdd.20', 'Monument Advisor Select 2008.mdd.30', 'Monument Advisor Select 2008.mdd.40',
    ]
  };

  return (
    DISABLE_ONBOARDING_MAP.managerType.includes(portfolioMetadata.managerType) ||
    DISABLE_ONBOARDING_MAP.singleStrategy.includes(portfolioMetadata.singleStrategy)
  )
}

export const CyManagerTypes = {
  getManagerTypes,
  disabledOnboarding
};



// WEBPACK FOOTER //
// ./src/utilities/managerTypes.js